/**
 * Fusszeile aller Tresor-Seiten.
 *
 * Der "Nix"-Streifen ersetzt seit dem 27.08.2026 den frueheren Cookie-Hinweis.
 * Er ist bewusst kein Einwilligungsbanner mehr: Nach dem Entfernen von Google Ads
 * bleiben nur noch die Anmelde-Cookies uebrig, und die sind nach § 25 Abs. 2 Nr. 2
 * TDDDG einwilligungsfrei. Es gibt deshalb nichts zu akzeptieren und nichts
 * wegzuklicken.
 *
 * Jede Aussage in diesem Streifen muss ein Nutzer mit den Entwicklertools
 * widerlegen koennen und darf es nicht. Deshalb steht dort "Nix Werbe-Cookies"
 * und nicht "Nix Cookies": dp_session, dp_refresh und dp_tresor_device
 * existieren wirklich, sobald jemand angemeldet ist.
 */

import { IS_EMBEDDED } from './embed';

const NIX_ICON = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.6,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  className: 'ed-nix-icon',
  'aria-hidden': true,
  focusable: 'false',
};

function KeksDurchgestrichen() {
  return (
    <svg {...NIX_ICON}>
      <circle cx="12" cy="12" r="8.4" />
      <circle cx="9" cy="9.4" r="1.1" fill="currentColor" stroke="none" />
      <circle cx="15.2" cy="11.2" r="1" fill="currentColor" stroke="none" />
      <circle cx="10.9" cy="15.4" r="1.2" fill="currentColor" stroke="none" />
      <path d="M3.9 20.1 20.1 3.9" />
    </svg>
  );
}

function FernglasDurchgestrichen() {
  return (
    <svg {...NIX_ICON}>
      <circle cx="6.4" cy="15.4" r="3.5" />
      <circle cx="17.6" cy="15.4" r="3.5" />
      <path d="M10 15.4h4" />
      <path d="M4.9 12.4V5.6A1.6 1.6 0 0 1 6.5 4h1.3a1.6 1.6 0 0 1 1.6 1.6v6.8" />
      <path d="M14.6 12.4V5.6A1.6 1.6 0 0 1 16.2 4h1.3a1.6 1.6 0 0 1 1.6 1.6v6.8" />
      <path d="M9.4 7.6h5.2" />
      <path d="M3.9 20.1 20.1 3.9" />
    </svg>
  );
}

export default function SiteFooter() {
  // Eingebettet hat das Dashboard seine eigene Fusszeile.
  if (IS_EMBEDDED) return null;
  return (
    <footer className="ed-site-footer">
      <div className="ed-nix-bar">
        <p className="ed-nix-claims">
          <span className="ed-nix-claim"><KeksDurchgestrichen /> Nix Werbe-Cookies</span>
          <span className="ed-nix-claim"><FernglasDurchgestrichen /> Nix Tracking</span>
        </p>
        <p className="ed-nix-note ed-muted">
          Kein Google, kein Analyse-Dienst, kein Werbepixel, kein Fremdskript. Das können Sie im
          Netzwerk-Tab Ihres Browsers nachsehen, es geht keine einzige Anfrage an einen fremden
          Anbieter raus. Cookies setzen wir nur, damit Ihre Anmeldung haelt.{' '}
          <a href="/datenschutz#cookies" className="ed-nix-link">Welche das genau sind</a>
        </p>
      </div>
      <div className="ed-site-footer-inner">
        <nav className="ed-site-footer-nav" aria-label="Weiterführende Links">
          <a href="/blog/" className="ed-link text-sm">Magazin</a>
          <a href="https://datenputzer.de/impressum.html" className="ed-link text-sm">Impressum</a>
          <a href="https://datenputzer.de/datenschutz#tresor" className="ed-link text-sm">Datenschutz</a>
          <a href="/agb" className="ed-link text-sm">AGB</a>
          <a href="https://datenputzer.de/widerrufsbelehrung" className="ed-link text-sm">Widerrufsbelehrung</a>
          <a href="https://datenputzer.de/kuendigen" className="ed-link text-sm">Verträge hier kündigen</a>
          <a href="https://datenputzer.de/widerruf" className="ed-widerruf text-sm">Vertrag widerrufen</a>
          <a href="/docs" className="ed-link text-sm">Technische Doku</a>
          <a href="/nachpruefen" className="ed-link text-sm">Quelltext nachprüfen</a>
        </nav>
        <p className="ed-site-footer-copy ed-muted text-sm">
          © {new Date().getFullYear()} Datenputzer Tresor · Hosting in Deutschland · ⚡ Lightning akzeptiert
        </p>
      </div>
    </footer>
  );
}
